import { render, staticRenderFns } from "./TipoEnvolvidoAssinatura.vue?vue&type=template&id=51d5a1ba&scoped=true"
import script from "./TipoEnvolvidoAssinatura.vue?vue&type=script&lang=js"
export * from "./TipoEnvolvidoAssinatura.vue?vue&type=script&lang=js"
import style0 from "./TipoEnvolvidoAssinatura.vue?vue&type=style&index=0&id=51d5a1ba&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d5a1ba",
  null
  
)

export default component.exports